import { Context } from 'aws-lambda';
// @ts-ignore
import AWSXRay from 'aws-xray-sdk-core';
import _ from 'lodash';
import { isLocal } from './environment';
import { getLoggerInstance } from './logger';
import { errorResponse, successResponse } from './responses';
import * as SentryUtils from './sentry-utils';

const logger = getLoggerInstance();

// Configure AWS X-Ray
AWSXRay.setLogger(logger);
if (!isLocal) {
  logger.trace('capturing outgoing http calls in X-Ray');
  // tslint:disable-next-line no-var-requires
  AWSXRay.captureHTTPsGlobal(require('http'));
}

export interface IHandlerOptions {
  returnRawResponse?: boolean;
}
export type InnerHandler = (event: any, context?: Context) => Promise<any>;

/**
 * @param options - Either pass options or the handler function
 * @param options.returnRawResponse - If true the it doesn't apply the successResponse wrapper
 * @param handler - The lambda function handler
 */
export default function handlerWrap(handler: InnerHandler, options: IHandlerOptions = {}) {
  if (_.isFunction(options)) {
    // tslint:disable-next-line no-parameter-reassignment
    handler = options;
  }

  return async (event: /* could be any event type */ any, context: Context) => {
    try {
      SentryUtils.init();
      SentryUtils.addInvokeBreadcrumb({ event, context });
      logger.setContext(context);
      logger.info({ event, context }, 'invoke');
      const result = await handler(event, context);
      if (typeof options !== 'function' && options.returnRawResponse) {
        logger.info({ response: result }, 'response');
        return result;
      }
      return successResponse(result);
    } catch (error) {
      applyErrorRules(error);
      logger.error({ error }, 'handlerWrap caught error');
      await SentryUtils.drain();
      if (typeof options !== 'function' && options.returnRawResponse) {
        throw error;
      }
      return errorResponse(error);
    }
  };
}

function applyErrorRules(error: any) {
  error.statusCode = error.statusCode || 500;
  if (error.name === 'ValidationError') {
    // it's an error from mongoose, DON'T report
    error.statusCode = 400;
    error.report = false;
  }
}
